import Box from "@mui/material/Box";
import { NavLink } from "react-router-dom";
import { isDefined } from "@pheaa/channels-component-library";
import styled from "@emotion/styled";

const HeaderLink = props => {

	const {
		component,
		fontSize = 16,
		fontWeight = 600,
		icon,
		text,
		textWrap = true,
		...rest
	} = props;

	const StyledLink = styled(component ? component : NavLink)(({ theme }) => ({
		alignItems: "center",
		color: theme.palette.primary.contrastText,
		display: "flex",
		flexDirection: "column",
		fontFamily: theme.typography.fontFamily,
		fontSize: fontSize || 16,
		fontWeight: fontWeight || theme.typography.fontWeightBold,
		justifyContent: "center",
		minHeight: 85
	}));

	return (
		<Box className="cmp-header__link-box" data-icon={isDefined(icon) ? true : null}>
			<StyledLink className="cmp-header__link" {...rest}>
				{icon}
				<span className="cmp-header__link-text" style={!textWrap ? { whiteSpace: "nowrap" } : null}>
					{text}
				</span>
			</StyledLink>
		</Box>
	);
};

export default HeaderLink;